import { render, staticRenderFns } from "./ours.vue?vue&type=template&id=2b06c4d8&scoped=true&"
import script from "./ours.vue?vue&type=script&lang=js&"
export * from "./ours.vue?vue&type=script&lang=js&"
import style0 from "./ours.vue?vue&type=style&index=0&id=2b06c4d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b06c4d8",
  null
  
)

export default component.exports